import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Buildings, CreditCard, TrendUp, ChartLineUp, ChartBar, Receipt, Palette, Globe, EnvelopeSimple, Database, Scales, UsersThree, CaretRight } from "@phosphor-icons/react";

const PLATFORM_LINKS = [
  { to: "/platform/tenants", label: "SaaS Tenants", desc: "Manage all tenant workspaces", icon: Buildings, roles: ["super_admin"], platformAdminOnly: true },
  { to: "/platform/subscription-plans", label: "Subscription Plans", desc: "Plans, pricing and feature tiers", icon: CreditCard, roles: ["super_admin"], platformAdminOnly: true },
  { to: "/platform/trial-conversions", label: "Trial Conversions", desc: "Track trials converting to paid", icon: TrendUp, roles: ["super_admin"], platformAdminOnly: true },
  { to: "/platform/api-usage", label: "API Usage", desc: "Per-tenant API consumption", icon: ChartLineUp, roles: ["super_admin"], platformAdminOnly: true },
  { to: "/platform/revenue", label: "Revenue", desc: "MRR and revenue analytics", icon: ChartBar, roles: ["super_admin"], platformAdminOnly: true },
  { to: "/platform/billing", label: "Billing", desc: "Your subscription and invoices", icon: Receipt, roles: ["super_admin", "admin"], platformAdminOnly: false },
  { to: "/platform/branding", label: "Branding", desc: "White-label colours, logo and domain", icon: Palette, roles: ["super_admin", "admin"], platformAdminOnly: false },
  { to: "/platform/webhooks", label: "Webhooks", desc: "Outbound event integrations", icon: Globe, roles: ["super_admin", "admin"], platformAdminOnly: false },
  { to: "/platform/email-templates", label: "Email Templates", desc: "Customise system email designs", icon: EnvelopeSimple, roles: ["super_admin", "admin"], platformAdminOnly: false },
  { to: "/platform/data-management", label: "Data Management", desc: "Import, export and retention", icon: Database, roles: ["super_admin", "admin"], platformAdminOnly: false },
  { to: "/platform/audit-export", label: "Audit Export", desc: "Compliance-grade audit downloads", icon: Scales, roles: ["super_admin", "admin"], platformAdminOnly: false },
  { to: "/platform/tenant-comparison", label: "SaaS Tenant Comparison", desc: "Benchmark tenants side by side", icon: UsersThree, roles: ["super_admin"], platformAdminOnly: true },
];

export default function SaasPlatformSection() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const visible = PLATFORM_LINKS.filter(l => l.roles.includes(user?.role) && (!l.platformAdminOnly || user?.is_platform_admin));

  return (
    <div data-testid="saas-platform-section">
      <div className="mb-4">
        <h2 className="text-base font-semibold font-[Chivo] flex items-center gap-2"><Buildings size={18} /> SaaS Platform</h2>
        <p className="text-xs text-muted-foreground mt-0.5">White-label platform administration — tenants, billing, branding and integrations.</p>
      </div>
      {visible.length === 0 ? (
        <p className="text-sm text-muted-foreground p-6 border border-border rounded-md">Your account does not have access to platform administration.</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {visible.map(l => (
            <button key={l.to} onClick={() => navigate(l.to)}
              className="group flex items-start gap-3 p-4 rounded-md border border-border bg-card text-left hover:border-primary/50 hover:bg-muted/40 transition-colors"
              data-testid={`platform-link-${l.to.split("/").pop()}`}>
              <div className="h-9 w-9 rounded-md bg-primary/10 flex items-center justify-center shrink-0">
                <l.icon size={18} className="text-primary" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold flex items-center gap-1">{l.label}
                  <CaretRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                </p>
                <p className="text-[11px] text-muted-foreground mt-0.5">{l.desc}</p>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
